import {API_URL} from '../../../../resources/api';

export const winLosesURL : string = `${API_URL}dashboard/servers/winloses`;
export const rankURL : string = `${API_URL}dashboard/servers/rank`;
export const resumeURL : string = `${API_URL}dashboard/servers/resume`;